import React from "react";
import { useCustomRouter } from "../../hooks/useCustomRouter";
import {
  siteDarkGreen,
  sitePurple,
  siteLightBlue,
  siteYellow
} from "../../providers/Theme";
import {
  Section,
  SectionHeading,
  CardsGrid,
  Card,
  CardTitle,
  CardBody,
  CardButton,
  DisclaimerBand,
  DisclaimerText
} from "./styled.components";

const cards = [
  {
    bg: siteDarkGreen,
    title: "Donate",
    body: "Support life-saving education and outreach initiatives.",
    label: "Give Today →",
    path: "donate"
  },
  {
    bg: sitePurple,
    title: "Partner With Us",
    body: "Collaborate to expand food allergy awareness in your community.",
    label: "Learn More →",
    path: "about-us/collaborators"
  },
  {
    bg: siteLightBlue,
    title: "Take Kyah's EPICourse",
    body: "Enroll in a free EPICourse for schools or food service.",
    label: "Enroll →",
    path: "trainings"
  },
  {
    bg: siteYellow,
    title: "Spread Awareness",
    body: "Share our mission to help save more lives.",
    label: "Share Now →",
    path: "get-involved/advocate-for-change"
  }
];

const GetInvolved: React.FC = () => {
  const customRouter = useCustomRouter();

  return (
    <Section>
      <SectionHeading>Get Involved</SectionHeading>
      <CardsGrid>
        {cards.map(c => (
          <Card key={c.path} bg={c.bg}>
            <CardTitle>{c.title}</CardTitle>
            <CardBody>{c.body}</CardBody>
            <CardButton onClick={() => customRouter.append(c.path)}>
              {c.label}
            </CardButton>
          </Card>
        ))}
      </CardsGrid>
      <DisclaimerBand>
        <DisclaimerText>
          The information provided here is for educational purposes only and is
          not intended to replace the medical advice of a doctor or healthcare
          provider. This information is provided by the Kyah Rayne Foundation, a
          qualified 501(c)(3) tax-exempt organization. By accessing this website
          and the resources located on this website, the visitor acknowledges
          that there is no physician-patient relationship between them and the
          authors. If you think you are observing a medical emergency such as
          but not limited to an allergic reaction, call 911 immediately.
        </DisclaimerText>
      </DisclaimerBand>
    </Section>
  );
};

export default GetInvolved;
